import { mediatorSettings } from "../index.js";
/**
 * Decorate the notificationHandler with this attribute
 *
 * @param value The request type
 * @param order The order of event
 */
var notificationHandler = function (value) {
    return function (target) {
        mediatorSettings.dispatcher.notifications.add({
            notification: value,
            handler: target
        });
    };
};
export default notificationHandler;
//# sourceMappingURL=notification.attribute.js.map